import { useResizeDetector } from 'react-resize-detector';

export const useIsMobile = () => {
  const { width } = useResizeDetector();
  return width ? width < 768 : window.innerWidth < 768;
};
